/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, AfterContentChecked, OnDestroy } from '@angular/core';
import { SchemaField, Document, TextFieldFormat, DocumentSchema, SystemFieldType } from '../../../store/models/document.model';
import { DynamicField } from '../dynamic-field';
import { TranslateService } from '@ngx-translate/core';
import { ViewComponent } from '../../../store/models/workflow.model';
import { DocumentReader } from 'src/app/modules/core/store/models';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-auto-increment-field',
    templateUrl: './auto-increment-field.component.html',
    styleUrls: ['./auto-increment-field.component.scss'],
    standalone: false
})
export class AutoIncrementFieldComponent implements AfterContentChecked, DynamicField, OnDestroy {
  hasEditorBeenInitialized: boolean;
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() set field(value: SchemaField) {
    this._field = value;
    this.fieldUId = value.uId;
    this.format = TextFieldFormat.SingleLine;
  }
  get field(): SchemaField {
    return this._field;
  }
  _field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  get document(): Document {
    return this.reader.document;
  }
  reader: DocumentReader;
  @Input() viewComponent: ViewComponent;
  @Input() schema: DocumentSchema;
  @Input() dataset: Dataset;
  valueForDisplay: string;
  showFieldAsEdit: boolean = false;
  fieldUId: string;

  set value(val: string) {
    if (!val) {
      val = '';
    }

    this.valueForDisplay = val || '---';
    this._value = val;
  }
  get value(): string {
    if (!this._value) {
      this._value = '';
    }

    if (this.format === TextFieldFormat.SingleLine && this._isEdit) {
      const textBox = document.getElementById(this.fieldUId) as HTMLInputElement;
      this._value = textBox?.value;
    }

    return this._value;
  }

  _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  _value: string;

  format: string;
  isReadOnly = false;
  TextFieldFormat = TextFieldFormat;
  editorConfig = {
    placeholder: ''
  };
  controlHeight = 32;

  constructor(private translate: TranslateService, private store: Store<any>) {
    this.translate.get('FIELDS.START-TYPING-HERE').subscribe(val => (this.editorConfig.placeholder = val));
  }

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  ngAfterContentChecked(): void {
    this.value = this.reader.getFieldValue(this.field?.systemName);
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  tpOnContentUpdated(): void {
    this.hasEditorBeenInitialized = false;
    this.value = this.reader.getFieldValue(this.field?.systemName);

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }
}
